<template>
	<div>
		<q-btn v-if="!confirming" @click="onStartClicked()" :disabled="isDisabled" :flat="isFlat" :color="color || 'green'" size="18px" :label="props.label" :icon-right="icon" no-wrap>
		</q-btn>
		<q-btn v-if="confirming && iconConfirm" class="gt-xs" @click="onConfirmedClicked()" :flat="isFlat" :color="color || 'green'" size="18px" :label="props.labelConfirm" :icon-right="iconConfirm" >
		</q-btn>
	</div>
</template>

<script setup lang="ts">

interface Props {
  item: Object,
  action: (item?: any) => void,
  icon: string,
  iconConfirm?: string,
  label: string,
  labelConfirm?: string,
  color?: string,
  isFlat?: boolean
  isDisabled?: boolean
};

	const props = defineProps<Props>();
	const confirming = ref(false);

	const onStartClicked = () => {
		if(!props.iconConfirm) {
			confirming.value = false;
			props.action(props.item);
		} else {
			confirming.value = true;
			setTimeout(() => {
				confirming.value = false;
			}, 2000);
		}
	}

	const onConfirmedClicked = () => {
		props.action(props.item);
	}
</script>